const AppLogo = () => (
	<svg width={64} height={64} fill="none">
		<g clipPath="url(#a)">
			<mask
				id="b"
				width={64}
				height={64}
				x={0}
				y={0}
				maskUnits="userSpaceOnUse"
				style={{
					maskType: 'luminance'
				}}
			>
				<path
					fill="#fff"
					fillRule="evenodd"
					d="M32 0C6.4 0 0 6.4 0 32s6.4 32 32 32 32-6.4 32-32S57.6 0 32 0Z"
					clipRule="evenodd"
				/>
			</mask>
			<g mask="url(#b)">
				<path fill="#0086FF" d="M0 0h64v64H0z" />
				<path
					fill="#fff"
					d="M30.962 49.33c-2.877 0-5.105-.467-7.054-1.4-1.671-.746-2.32-1.865-2.135-3.544 0-.374.186-2.333.278-2.892.186-1.213.65-1.866 1.3-1.866.371 0 .835.187 1.392.56 1.671 1.12 3.527 2.145 5.662 2.145.279 0 4.178.093 4.456-2.798.093-.933-.371-1.866-1.3-2.426-1.02-.653-3.62-1.865-3.805-1.959-1.393-.652-2.6-1.306-3.62-2.052-2.507-1.865-3.064-5.597-3.064-5.597-.185-1.212-1.3-2.239-2.599-2.239h-2.877c-.743 0-1.3-.56-1.3-1.305v-.187c0-.746.557-1.306 1.3-1.306h7.333c1.3 0 2.32-1.026 2.32-2.332v-.187a2.304 2.304 0 0 0-2.32-2.332h-3.62c-.743 0-1.3-.56-1.3-1.306v-.186c0-.746.557-1.306 1.3-1.306h14.387c1.022 0 4.456 0 7.148 2.052 1.02.746 1.3 1.772-.093 4.011-.928 1.493-1.67 2.146-2.413 2.146-.279 0-.65-.094-1.022-.28-1.299-.56-2.691-.84-4.177-.84-.37 0-3.434-.28-4.084 2.053-.371 1.305.279 2.332 1.578 3.078.743.373 4.084 2.052 5.105 2.518 2.414 1.306 4.734 2.985 5.106 6.064.464 4.198-.279 7.463-2.228 9.795-3.249 4.197-9.56 3.918-9.654 3.918Z"
				/>
			</g>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h64v64H0z" />
			</clipPath>
		</defs>
	</svg>
);

export default AppLogo;
